const initialState = {};

const resetpassword = function (state = initialState, action) {
  switch (action.type) {
    default: {
      return state;
    }
  }
};

export default resetpassword;
